import {createSlice, ActionReducerMapBuilder} from '@reduxjs/toolkit'
import {SliceStatus} from 'interfaces'
import {
  validateURL,
  validateURLFailure,
  validateURLSuccess,
} from './Settings/settingsActions'

type UserSliceState = {
  validateURL: {auth_provider: string; auth_url: string}
  status: SliceStatus
  error: string
}
const adminSlice = createSlice({
  name: 'admin',
  initialState: {
    validateURL: {auth_provider: '', auth_url: ''},
    status: SliceStatus.idle,
    error: '',
  },
  reducers: {},
  extraReducers: (builder: ActionReducerMapBuilder<UserSliceState>) =>
    builder
      .addCase(validateURL, state => ({
        ...state,
        status: SliceStatus.pending,
      }))
      .addCase(validateURLFailure, state => ({
        ...state,
        status: SliceStatus.rejected,
      }))
      .addCase(validateURLSuccess, (state, action) => ({
        ...state,
        status: SliceStatus.resolved,
        validateURL: action.payload,
      }))

      .addDefaultCase(state => state),
})

export const {reducer: adminReducer, name: adminReducerName} = adminSlice

export type TAdminActions =
  | ReturnType<typeof validateURL>
  | ReturnType<typeof validateURLFailure>
  | ReturnType<typeof validateURLSuccess>

export const adminActions = {
  validateURL,
  validateURLFailure,
  validateURLSuccess,
}

export type AdminState = ReturnType<typeof adminReducer>
